
import axios from 'axios';


// let baseURI = "http://local.castor.backend.com/api";
let baseURI = "https://castor-backend.solidaridadasia.com/api";

export default axios.create({
    baseURL: baseURI,
    timeout: 1500000,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})